export default {"src":"/_next/static/image/src/images/amica-logo-dark.c4b83f915b322961deffcf55acc00fb3.svg","height":20,"width":74};